<template>
    <div class="searchContactsInput">
        <div class="searchContactsInput__chooseItem">
            <form-dropdown
                id="dropdown-search-item"
                ref="dropdown"
                :label="label"
                :placeholder="placeholder"
                :hideLabelColon="hideLabelColon"
                :settings="dropdownSettings"
            />
        </div>

        <a
            v-if="query || selectedItem"
            class="searchContactsInput__clear"
            @click.prevent="handleClearSearch"
        >
            <fa-icon v-if="busy" icon="circle-notch" spin />
            <fa-icon v-else icon="times" />
        </a>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import InitialsMixin from '../../../mixins/initials.js';

export default {
    emits: ['setState'],
    
    mixins: [InitialsMixin],

    props: {
        focus: { type: Boolean, default: false },
        busy: { type: Boolean, default: false },
        label: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        hideLabelColon: { type: Boolean, default: false },
        selectedItem: { type: [Object, null], default: null },
    },

    data() {
        return {
            query: '',
        };
    },

    computed: {
        dropdown() {
            return this.$refs.dropdown.$refs.dropdown.$el.selectize;
        },

        dropdownSettings() {
            return {
                valueField: 'id',
                options: [],
                highlight: true,
                render: {
                    item: this.dropdownItem,
                    option: this.dropdownOption,
                },
                maxItems: 1,
                onItemRemove: (value) => {
                    this.$emit('setState', {
                        selectedItem: null,
                    });
                },
                onItemAdd: (value, item) => {},
                onOptionAdd: (value, data) => {},
                onClear: () => {},
            };
        },

        ...mapState(stores.Search, [
            'querySearch',
            'canSearchQuery',
            'hasTypeSearch',
            'hasTypeItemsSearch',
            'searchExistItemsCount',
        ]),
    },

    watch: {
        querySearch(value) {
            if (!value) {
                this.query = '';
                this.dropdown.setTextboxValue('');
            }
        },

        query(value) {
            this.$rootEvents.$emit('handleUpdateSearch', value);
        },

        'selectedItem.id'(id) {
            if (id) {
                this.dropdown.addOption(this.selectedItem);
                this.dropdown.addItem(this.selectedItem.id);
            }
        },
    },

    methods: {
        initEvent() {
            const $control_input = this.dropdown.$control_input;

            if ($control_input) {
                $control_input.on('blur', this.handleBlur);
                $control_input.on('focus', this.handleFocus);
                $control_input.on('keyup', (e) => {
                    this.query = e.target.value;
                });
            }
        },

        removeEvent() {},

        handleFocus(e) {
            this.$rootEvents.$emit('handleFocus', e);
        },

        handleClearSearch() {
            this.$emit('setState', {
                selectedItem: null,
                showDropDown: false,
            });
            this.$store.dispatch('searchUpdateState', {
                querySearch: '',
            });
        },

        async handleBlur() {
            await this.$delay(1);

            this.dropdown.setTextboxValue(this.query);

            this.$rootEvents.$emit('handleBlur');
        },

        handleClose() {
            this.$rootEvents.$emit('handleClose');
        },

        dropdownItem(item) {
            const contact = item.integrationInfo;

            return `<div class="selectize-contact">
                    <div class="selectize-contact-info">
                        ${contact.full_name} - ${contact.phone}
                    </div>
                </div>
                `;
        },

        dropdownOption(item, escape) {
            return '<div class="dn"></div>';
        },
    },

    mounted() {
        this.initEvent();
    },

    beforeUnmount() {
        this.removeEvent();
    },
};
</script>
